import { Helmet } from 'react-helmet';
import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography
} from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import PropTypes from 'prop-types';
import { ProductContext } from 'src/context/ProductContext';
import ProductProfileDetails from 'src/components/product/ProductProfileDetails';

function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const tab = {
  color: '#FFF'
};

const tabSelected = {
  color: '#FFF',
  borderBottom: '5px solid red'
};

const ProductForm = () => {
  const { id, branch } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    product,
    setProduct,
    getProduct,
    saveProduct,
    updateProduct,
  } = useContext(ProductContext);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(async () => {
    if (id) {
      await getProduct(id);
    } else {
      setProduct(null);
    }
  }, []);

  const backClient = () => {
    if (product) {
      navigate(`/app/branch/${product.branch_id}`, { replace: true });
    } else {
      navigate(`/app/branch/${branch}`, { replace: true });
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {`Client | ${process.env.REACT_APP_NAME}`}
        </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth="lg">
          {loading === false
            ? (
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      marginBottom: '10px',
                      justifyContent: 'flex-end'
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={backClient}
                    >
                      Voltar
                    </Button>
                  </Box>
                  <AppBar position="static">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                      <Tab style={value === 0 ? tabSelected : tab} label="Dados" {...a11yProps(0)} />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={value} index={0} style={{ backgroundColor: '#fff' }}>
                    <ProductProfileDetails
                      product={product}
                      saveform={saveProduct}
                      updateform={updateProduct}
                    />
                  </TabPanel>
                </Grid>
              </Grid>
            )
            : <></> }
        </Container>
      </Box>
    </>
  );
};
export default ProductForm;
